import { Builder as RawBuilder, IfRender } from '@finn/platform-modules';

import {
  ReturnRentetionBanner,
  ReturnRentetionBannerProps,
} from './ReturnRentetionBanner';

export const WrapperBuilder = (props: any) => {
  return (
    <RawBuilder {...props}>
      {props.banners?.map((banner: ReturnRentetionBannerProps) => (
        <IfRender
          key={banner.description}
          visibilityConfig={banner.config?.visibilityConfig}
        >
          <ReturnRentetionBanner {...banner} />
        </IfRender>
      ))}
    </RawBuilder>
  );
};
